import React from 'react'

const Help = () => {
    return (
        <div className="help bg-green-400 flex-1">
            
        </div>
    )
}

export default Help
